import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import './error.css'
class Error404 extends Component {

render() {

    
    return (
        <div className='errorpages'>
            <div>
                404
            </div>
            <div className='errorsub'>
                <div>
                    We sincerely apologize
                </div>
                <div>
    The page you are looking for is no longer here.Maybe it was never here in the first place.In any case,we are sorry you were send here.            </div>
                <div>
                    <Link to='/'>
                    <button>GO HOME</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}
}


export default Error404;
